import { useCallback } from "react";
import { useNavigate } from "react-router";
import { termDestination, type TermTarget } from "../terms/term-route";

/**
 * Where a drawn element's numeral in a claim goes: Figures' Define step, which
 * opens the first figure that pins the element and highlights its row. The same
 * route the Terminology panel takes to a component (N5b), shown and not opened
 * for editing, since a claim cites the element and does not change it.
 */
export function useOpenOnDrawing(taskId: string): (elementId: string) => void {
  const navigate = useNavigate();
  return useCallback(
    (elementId: string) => {
      const term: TermTarget = { recordId: elementId, edit: false };
      void navigate(termDestination(taskId, "components"), {
        state: { term },
      });
    },
    [navigate, taskId],
  );
}
